import { ISelectOption } from '../Select';

export const onInputChangeSelectList =
  (dataSource: ISelectOption<string>[], setList: (x: ISelectOption<string>[]) => void) =>
  (x: string, { action }: { action: string }) => {
    if (action === 'input-change') {
      const startsWith = dataSource.filter((t) => t.label.toLowerCase().startsWith(x.toLowerCase()));
      const contains = dataSource.filter(
        (t) => startsWith.indexOf(t) < 0 && t.label.toLowerCase().indexOf(x.toLowerCase()) >= 0
      );
      setList([...startsWith, ...contains]);
    }
  };
